<template>
	<div class="app">
		<AppHeader />
		<div class="app-body">
			<Sidebar :navItems="nav" />
			<main class="main">
				<breadcrumb :list="list" />
				<div class="container-fluid">
					<router-view></router-view>
				</div>
			</main>
			<AppAside />
		</div>
		<AppFooter />
	</div>
</template>

<script>
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import settings from '@/settings.js';

export default {
	name: 'Full',
	components: {
		AppHeader,
		Sidebar,
		AppAside,
		AppFooter,
		Breadcrumb
	},
	data () {
		return {
		}
	},
	computed: {
		name () {
			return this.$route.name
		},
		list () {
			return this.$route.matched
		},
		nav () {
			let items = [];
			if (this.$store.getters.user !== null && (settings.vozilaRoles.includes(this.$store.getters.user.role) || settings.highPermissionsRoles.includes(this.$store.getters.user.role))) {
				items.push({
					name: 'Domov',
					url: '/dashboard',
					icon: 'icon-speedometer'
				});
				items.push({
					name: 'Aktivnosti',
					url: '/aktivnosti',
					icon: 'icon-list'
				});
				items.push({
					name: 'Zaloga',
					url: '/tabla',
					icon: 'icon-layers'
				});
				items.push({
					name: 'Kupci',
					url: '/kupci',
					icon: 'icon-people'
				});
				items.push({
					name: 'Prilivi',
					url: '/prilivi',
					icon: 'icon-wallet'
				});
				items.push({
					name: 'Povračila',
					url: '/povracila',
					icon: 'icon-credit-card'
				});
			}
			if (this.$store.getters.user !== null && (settings.vozilaRoles.includes(this.$store.getters.user.role) || settings.highPermissionsRoles.includes(this.$store.getters.user.role) || settings.poprodajaRoles.includes(this.$store.getters.user.role))) {
				items.push({
					name: 'Izdaja',
					url: '/izdaja',
					icon: 'icon-calendar'
				});
			}
			// hotel gum
			if (this.$store.getters.user !== null && (settings.hotelGumRoles.includes(this.$store.getters.user.role) || settings.highPermissionsRoles.includes(this.$store.getters.user.role) || settings.poprodajaRoles.includes(this.$store.getters.user.role))) {
				items.push({
					name: 'Hotel gum',
					url: '/hotel',
					icon: 'icon-grid'
				});
			}
			// only for moderators and admins
			if (this.$store.getters.user !== null && (this.$store.getters.user.role === 4 || this.$store.getters.user.role === 5)) {
				items.push({
					name: 'Nastavitve',
					url: '/nastavitve',
					icon: 'icon-settings',
					children: [
						{
							name: 'Uporabniki',
							url: '/nastavitve/uporabniki',
							icon: 'icon-user'
						}
					]
				});
			}
			return items;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue